// extracted by mini-css-extract-plugin
export default {"stopBodyYScroll":"NsWAmY","contentContainer":"iqwBlY","root":"pfKxjS"};